import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungLeverkusen() {
  return (
    <CityPageTemplate
      city="Leverkusen"
      slug="leverkusen"
      intro="Leverkusen zwischen Köln und Düsseldorf – wir bringen Deine Finanzen auf Meisterschaftsniveau."
      description="Unabhängige & digitale Finanzberatung für Leverkusen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
